// extracted by mini-css-extract-plugin
module.exports = {"summaryItem":"ResourcesBody-module_summaryItem","containerResourcesBody":"ResourcesBody-module_containerResourcesBody","colEnd":"ResourcesBody-module_colEnd"};